export default __webpack_public_path__ + "static/media/ic-warning.674b6913.svg";